export var PaymentType;
(function (PaymentType) {
    PaymentType["InterestOnly"] = "INTEREST_ONLY";
    PaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    PaymentType["Both"] = "BOTH";
    PaymentType["StillDeciding"] = "STILL_DECIDING";
    PaymentType["Unknown"] = "UNKNOWN";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=PaymentType.js.map